class JWToken {

  constructor (customerId) {
    this.customerId = customerId
  }

  async getToken () {
    if (!this.token || !this.timestamp) {
      let storedToken = localStorage.getItem(
        'expertifyToken_' + String(this.customerId)
      )
      if (storedToken == null) {
        storedToken = await this.getNewToken()
      }

      let parsed = JSON.parse(storedToken)
      this.timestamp = parsed.timestamp
      this.token = parsed.token
    }

    let now = +new Date() / 1000

    if (now - this.timestamp > 900) {
      let storedToken = await this.getNewToken()
      let parsed = JSON.parse(storedToken)
      this.timestamp = parsed.timestamp
      this.token = parsed.token
    }
    return this.token
  }

  async getNewToken () {
    let resp = await fetch('/apps/gifties-service/jwt?customerId=' + this.customerId)
    let parsed = await resp.json()
    let data = { token: parsed.token, timestamp: +new Date() / 1000 }
    localStorage.setItem(
      'expertifyToken_' + String(this.customerId),
      JSON.stringify(data)
    )
    return JSON.stringify(data)
  }
}
